// extracted by mini-css-extract-plugin
export default {"productGallery":"_O-z","inQuickShop":"aP-z"};